export const WHATSAPP_NUMBER = '919876543210';
export const WHATSAPP_DISPLAY = '+91 98765 43210';
export const waLink = (message = "Hi Forge Fitness! I'd like to know more about your memberships.") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
